<div class="entrance">
  <div class="entrance-fv">
    <div class="entrance-fv-image">
      <h1>
        <img src="/assets/images/lp/entrance/logo.svg" alt="大学入試過去問Webサービス 旺文社 入試正解デジタル" class="logo" width="412  " />
      </h1>
      <img src="/assets/images/lp/entrance/main.png" alt="旺文社 入試正解デジタル 過去問題集" class="main-image" />
    </div>
    <p class="text-primary fv-text-title font-bold mt-10 hidden md:block">受験対策をもっと効率的に</p>
    <p class="fv-text font-bold mt-[2.625rem] hidden md:block">
      旺文社が刊行する『全国大学入試問題正解』の過去問、解答・解説を掲載。<br />
      全国200大学以上、10科目と小論文が閲覧できます。
    </p>
    <div class="fv-subjects hidden md:flex">
      <app-label-subject subjectLabelStyle="eigo" subjectLabelName="英語"></app-label-subject>
      <app-label-subject subjectLabelStyle="sugaku" subjectLabelName="数学"></app-label-subject>
      <app-label-subject subjectLabelStyle="kokugo" subjectLabelName="国語"></app-label-subject>
      <app-label-subject subjectLabelStyle="butsuri" subjectLabelName="物理"></app-label-subject>
      <app-label-subject subjectLabelStyle="kagaku" subjectLabelName="化学"></app-label-subject>
      <app-label-subject subjectLabelStyle="seibutsu" subjectLabelName="生物"></app-label-subject>
      <app-label-subject subjectLabelStyle="nihonshi" subjectLabelName="日本史"></app-label-subject>
      <app-label-subject subjectLabelStyle="sekaishi" subjectLabelName="世界史"></app-label-subject>
      <app-label-subject subjectLabelStyle="chiri" subjectLabelName="地理"></app-label-subject>
      <app-label-subject subjectLabelStyle="seikei" subjectLabelName="政治・経済"></app-label-subject>
      <span class="fv-subject-new">
        <app-label-subject subjectLabelStyle="suisen" subjectLabelName="小論文"></app-label-subject>
        <span class="fv-subject-new-pill">NEW</span>
      </span>
    </div>
    <p class="fv-text fv-subtext font-bold hidden md:block">
      学校推薦型・総合型選抜は、<br />
      『螢雪時代7月臨時増刊 大学入試 推薦＆総合型合格対策ガイド』の過去問も収録。
    </p>
  </div>
  <div class="entrance-block">
    <div class="entrance-block-inner">
      <a class="entrance-block-inner-hit" (click)="gotoBToCLp()">
        <h2 class="font-bold">
          高校生・大学受験生はこちら
        </h2>
        <h3><img src="/assets/images/app-logo-with-company.svg" alt="旺文社 入試正解デジタル for school" width="240" /></h3>
        <img src="/assets/images/lp/entrance/icon-student.png" alt="旺文社 入試正解デジタル高校生・大学受験生用" width="220" class="mt-4" />
        <ul class="font-bold">
          <li><mat-icon class="text-primary">check_circle</mat-icon>志望校の過去問対策</li>
          <li><mat-icon class="text-primary">check_circle</mat-icon>マイリストによる学習進捗管理</li>
          <li><mat-icon class="text-primary">check_circle</mat-icon>プレミアム登録で最大11年分の過去問が解ける</li>
        </ul>
      </a>

      <a class="entrance-block-inner-hit" (click)="gotoBToSLp()">
        <h2 class="font-bold">
          学校・塾の先生はこちら
        </h2>
        <h3><img src="/assets/images/app-logo-for-school-with-company.svg" alt="旺文社 入試正解デジタル" width="214" /></h3>
        <img src="/assets/images/lp/entrance/icon-school.png" alt="旺文社 入試正解デジタル for school" width="190" class="mt-4" />
        <ul class="font-bold">
          <li><mat-icon class="text-primary">check_circle</mat-icon>各科目に特化した過去問検索</li>
          <li><mat-icon class="text-primary">check_circle</mat-icon>入試問題を使ったプリント作成ができる</li>
        </ul>
      </a>
    </div>
  </div>

  <!-- 入試正解シリーズの歴史バナー -->
  <div class="entrance-history-block">
    <app-entrance-history-banner></app-entrance-history-banner>
  </div>
</div>
<app-common-id-footer footerTypeEntrance="true"></app-common-id-footer>
